import React from "react";
import { Navigate } from "react-router-dom";

import { useAuth } from "@/containers/Auth/AuthContext";

interface PrivateRouteProps {
  children: React.ReactNode;
}

export const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { authToken } = useAuth();
  return authToken ? <>{children}</> : <Navigate to="/" replace />;
};
